import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { InviteStore } from './+state/invite.store';
import { InviteService } from './service/invite.service';

export function provideInvite(): EnvironmentProviders {
  return makeEnvironmentProviders([InviteStore, InviteService]);
}
